import React from 'react';
import {
  IonContent,
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonMenuButton,
  IonIcon,
  IonText,
  IonButton,
} from '@ionic/react';
import { logoWhatsapp, chatbubbleOutline } from 'ionicons/icons';
import WhatsAppIntegration from '../components/WhatsAppIntegration';

const WhatsApp: React.FC = () => {
  const openWhatsAppChat = () => {
    const phoneNumber = '15556382524'; // +1 (555) 638-2524 formatted for WhatsApp
    const message = 'Hi! I want to link my ManageTix account to WhatsApp.';
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton menu="main-menu" />
          </IonButtons>
          <IonTitle className="flex items-center">
            <IonIcon icon={logoWhatsapp} className="mr-2 text-green-500" />
            WhatsApp
          </IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen className="bg-gray-50 dark:bg-gray-900">
        <div className="max-w-4xl mx-auto p-4">
          {/* Page Header */}
          <div className="mb-6 text-center">
            <IonIcon 
              icon={logoWhatsapp} 
              className="text-green-500 mb-4" 
              style={{ fontSize: '4rem' }} 
            />
            <IonText>
              <h1 className="text-2xl font-bold mb-2">WhatsApp Integration</h1>
              <p className="text-gray-600 dark:text-gray-400">
                Connect your WhatsApp to interact with ManageTix AI assistant
              </p>
            </IonText>
          </div>

          {/* WhatsApp Integration Component */}
          <WhatsAppIntegration />

          {/* Additional Information */}
          <div className="mt-8 p-6 bg-white dark:bg-gray-800 rounded-lg shadow-sm">
            <IonText>
              <h2 className="text-xl font-semibold mb-4 flex items-center">
                <IonIcon icon={logoWhatsapp} className="mr-2 text-green-500" />
                How It Works
              </h2>
              
              <div className="space-y-4">
                <div>
                  <h3 className="font-medium text-lg mb-2">📱 Easy Setup</h3>
                  <p className="text-gray-600 dark:text-gray-400">
                    Generate a secure linking token and send it to our WhatsApp number to connect your account.
                  </p>
                </div>

                <div>
                  <h3 className="font-medium text-lg mb-2">🤖 AI Assistant</h3>
                  <p className="text-gray-600 dark:text-gray-400">
                    Chat with our AI to add tickets, create sales, and manage your inventory using natural language.
                  </p>
                </div>

                <div>
                  <h3 className="font-medium text-lg mb-2">📸 Image Processing</h3>
                  <p className="text-gray-600 dark:text-gray-400">
                    Send photos of tickets or receipts and our AI will automatically extract ticket information.
                  </p>
                </div>

                <div>
                  <h3 className="font-medium text-lg mb-2">⚡ Real-time Updates</h3>
                  <p className="text-gray-600 dark:text-gray-400">
                    Get instant confirmations and updates on your ticket operations through WhatsApp.
                  </p>
                </div>
              </div>

              <div className="mt-6 p-4 bg-green-50 dark:bg-green-900/20 rounded-lg">
                <h3 className="font-medium text-lg mb-2 text-green-700 dark:text-green-400">
                  💡 Pro Tips
                </h3>
                <ul className="space-y-2 text-sm text-green-600 dark:text-green-300">
                  <li>• Use clear, specific language when describing tickets</li>
                  <li>• Include event names, dates, and sections for better results</li>
                  <li>• Send high-quality photos for accurate image processing</li>
                  <li>• You can always confirm or cancel actions before they're executed</li>
                </ul>
                
                <div className="mt-4">
                  <IonButton 
                    expand="block" 
                    color="success"
                    onClick={openWhatsAppChat}
                  >
                    <IonIcon icon={chatbubbleOutline} slot="start" />
                    Start WhatsApp Chat
                  </IonButton>
                </div>
              </div>
            </IonText>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default WhatsApp;